"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientTagType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PatientTag_1 = require("./PatientTag");
var PatientTagType_Factory = /** @class */ (function () {
    function PatientTagType_Factory() {
    }
    PatientTagType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            PatientTags: model.PatientTags && model.PatientTags.map(function (i) { return PatientTag_1.PatientTag_Factory.CreateIncoming(i); }),
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    PatientTagType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            PatientTags: model.PatientTags && model.PatientTags.map(function (i) { return PatientTag_1.PatientTag_Factory.CreateOutgoing(i); }),
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return PatientTagType_Factory;
}());
exports.PatientTagType_Factory = PatientTagType_Factory;
